module.exports = __webpack_public_path__ + "img/assessment-accelerator-intro.04c85756.png";